import * as NavConstants from 'constants/NavConstants';
import {AgentType, ChatType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ChatDraftStatus, createChatWithDraftMessage} from 'llm/chat-library/ChatActions';
import {openExistingChat} from 'llm/chat-library/sidepanel/AISidepanelV2GlobalClientState';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';

/**
 * Runs a suggested question by creating a new chat in ASK mode with the question as the initial message.
 * Opens the AI sidepanel with the new chat.
 *
 * Passes draft directly to createChatWithDraftMessage to avoid clobbering any user-authored draft.
 *
 * @param question - The question text to ask
 * @param fileId - The ID of the file the question is about
 * @param fileName - The name of the file the question is about
 * @returns Promise that resolves to the created chat ID
 */
export async function runSuggestedQuestion(
  question: string,
  fileId: string,
  fileName: string
): Promise<string> {
  const enrichedQuestion = `Regarding "${fileName}": ${question}`;

  const {chatSessionId} = await createChatWithDraftMessage(ChatType.DEEP_RESEARCH, {
    createParams: {contextIds: [fileId]},
    draft: {
      status: ChatDraftStatus.DRAFT,
      message: {text: enrichedQuestion, selectedFiles: []},
      settings: {agentType: AgentType.ASK, publicDataEnabled: false},
    },
  });

  // Open the chat in the AI sidepanel without fully expanding it
  openExistingChat(chatSessionId);
  SidepanelActions.openSection(NavConstants.SECTIONS.AI);

  return chatSessionId;
}
